import { StepDefinition } from "../../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../../core/flows/StepFlow";
import { RequestCorporateAccountContext } from "../Context/RequestCorporateAccountContext";


class RequestCorporateAccountInit extends StepFlow {
    get stepName() { return "RequestCorporateAccountInit_Step"; }

    async onEventSetup(): Promise<void> {
    }

    async onExecute(): Promise<void> {
        this.setCtx("requestCorporateAccountContext", RequestCorporateAccountContext)
        const context = this.getCtx<RequestCorporateAccountContext>("requestCorporateAccountContext")!
        context.routeTo = ["RequestCorporateAccount_Step"]
        this.next();

    }
}

export const requestCorporateAccountInitStepDeclaration = new StepDefinition({
    stepName: "RequestCorporateAccountInit_Step",
    stepClass: RequestCorporateAccountInit
});